/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolThumbUpIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-thumb-up"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M21.15 7.7Q22.2 7.7 23 8.5Q23.8 9.3 23.8 10.35L23.8 12.5Q23.8 12.7 23.75 12.93Q23.7 13.15 23.6 13.35L20.4 20.9Q20.13 21.45 19.56 21.82Q19 22.2 18.4 22.2L10 22.2Q8.88 22.2 8.11 21.44Q7.35 20.68 7.35 19.55L7.35 8.8Q7.35 8.28 7.55 7.79Q7.75 7.3 8.13 6.92L13 1.98Q13.6 1.35 14.4 1.2Q15.2 1.05 15.88 1.4Q16.55 1.75 16.81 2.5Q17.07 3.25 16.85 4.1L15.85 7.7ZM3.25 22.2Q2.38 22.2 1.76 21.59Q1.15 20.98 1.15 20.1L1.15 9.8Q1.15 8.93 1.76 8.31Q2.38 7.7 3.25 7.7L3.25 7.7Q4.13 7.7 4.74 8.31Q5.35 8.93 5.35 9.8L5.35 20.1Q5.35 20.98 4.74 21.59Q4.13 22.2 3.25 22.2Z" fill={color} />
    </svg>
  );
}
